import { create } from 'zustand';
import { Cart, CartItem } from '../types';
import { cartAPI } from '../api/cart';

interface CartState {
  cart: Cart | null;
  isLoading: boolean;
  isOpen: boolean;
  fetchCart: () => Promise<void>;
  addToCart: (
    product_id: string,
    variant_id: string,
    quantity: number,
    measurements?: Record<string, string | undefined>
  ) => Promise<void>;
  updateItem: (id: string, quantity: number) => Promise<void>;
  removeItem: (id: string) => Promise<void>;
  clearCart: () => Promise<void>;
  openCart: () => void;
  closeCart: () => void;
  toggleCart: () => void;
}

export const useCartStore = create<CartState>((set, get) => ({
  cart: null,
  isLoading: false,
  isOpen: false,

  fetchCart: async () => {
    const token = localStorage.getItem('lanre_savage_token');
    if (!token) return;
    try {
      set({ isLoading: true });
      const res = await cartAPI.getCart();
      if (res.success && res.data) {
        set({ cart: res.data });
      }
    } catch (error) {
      console.error('Failed to fetch cart:', error);
    } finally {
      set({ isLoading: false });
    }
  },

  addToCart: async (product_id, variant_id, quantity, measurements) => {
    try {
      set({ isLoading: true });
      await cartAPI.addToCart({ product_id, variant_id, quantity, measurements });
      await get().fetchCart();
      set({ isOpen: true });
    } catch (error) {
      throw error;
    } finally {
      set({ isLoading: false });
    }
  },

  updateItem: async (id, quantity) => {
    try {
      await cartAPI.updateCartItem(id, quantity);
      await get().fetchCart();
    } catch (error) {
      throw error;
    }
  },

  removeItem: async (id) => {
    try {
      await cartAPI.removeFromCart(id);
      await get().fetchCart();
    } catch (error) {
      throw error;
    }
  },

  clearCart: async () => {
    try {
      await cartAPI.clearCart();
      set({ cart: null });
    } catch (error) {
      throw error;
    }
  },

  openCart: () => set({ isOpen: true }),
  closeCart: () => set({ isOpen: false }),
  toggleCart: () => set((state) => ({ isOpen: !state.isOpen })),
}));